import * as React from 'react';
import { StatesViewModel } from '@models/common.models';
import { ControlProps } from 'react-redux-form';

export interface StatesSelectProps {
  readonly controlProps: ControlProps<HTMLSelectElement>;
  readonly statesOptions: StatesViewModel[];
  readonly loadStates: () => void;
}

export class StatesSelectComponent extends React.Component<StatesSelectProps> {
  componentDidMount() {
    this.props.loadStates();
  }

  renderStates() {
    if (!(this.props && this.props.statesOptions && this.props.statesOptions.length > 0)) {
      return <option key="-1">None Available</option>;
    }

    return this.props.statesOptions.map((option, index) => {
      return (
        <option key={index} value={option.abbreviation}>
          {option.abbreviation} - {option.name}
        </option>
      );
    });
  }

  render() {
    return (
      <select {...this.props.controlProps}>
        <option value="">Select state ...</option>
        {this.renderStates()}
      </select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/state-select/states-select.component.tsx